import { Button, Checkbox, Form, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";

import styles from "@/components/CustomerConsentTermsModal/CustomerConsentTermsModal.module.css";
import { getTermAndConditions } from "@/services/Auth/AuthApi";

interface CustomerConsentTermsModalProps {
  open: boolean;
  actionType?: string;
  onClose: () => void;
  onSubmit?: () => void;
  data?: any;
}

const CustomerConsentTermsModal: React.FC<CustomerConsentTermsModalProps> = ({
  open,
  actionType = "create_pledge",
  onClose,
  onSubmit,
  data,
}) => {
  const [form] = Form.useForm();
  const [consentText, setConsentText] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (): void => {
    setLoading(true);
    onSubmit?.();
    form.resetFields();
    onClose();
    setLoading(false);
  };
  useEffect(() => {
    if (open) {
      void fetchConsentText();
    }
  }, [open, actionType]);

  const fetchConsentText = async () => {
    try {
      setLoading(true);
      const type = actionType === "redeem_pledge" ? "redeem_pledge" : "create_pledge";
      const res = await getTermAndConditions(`type=${type}`);
      setConsentText(res?.data?.[0].content || "");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
      title="Customer Consent Terms"
      className={styles.otpModal}
    >
      <Spin spinning={loading}>
        <div className={styles.modalContainer}>
          <Form
            form={form}
            layout="vertical"
            initialValues={{ transfer_type: "internal" }}
            className={styles.formStyle}
            onFinish={handleSubmit}
          >
            <div
              style={{ maxHeight: 200, overflowY: "auto", marginBottom: 16 }}
              dangerouslySetInnerHTML={{ __html: consentText }}
            />
            {/* Checkbox */}
            <Form.Item
              name="consent"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value ? Promise.resolve() : Promise.reject("Please accept the consent terms"),
                },
              ]}
            >
              <Checkbox>I agree to the above Customer Consent Terms</Checkbox>
            </Form.Item>

            {/* Buttons */}
            <div className={styles.buttonRight}>
              <Button className={styles.clearButton} onClick={onClose}>
                Cancel
              </Button>
              <Button className={styles.applyButton} htmlType="submit" disabled={loading}>
                {loading ? "Please Wait.." : "Confirm"}
              </Button>
            </div>
          </Form>
        </div>
      </Spin>
    </Modal>
  );
};

export default CustomerConsentTermsModal;
